import styled from "styled-components";
import { TextSubHeader, Text } from "venice-ui";
import { Colors } from "../../untils/Theme";

export const OrganizationsWrapper = styled.div`
    width:calc(100% - 35rem);
    display:flex;
    flex-direction:column;
    gap:10px;
    height: calc(100vh - 16rem);
    align-items: flex-start;
    padding-right:0.5rem;
    box-sizing:border:box;
`;
export const OrganizationDetailsWrapper = styled.div`
    width:35rem;
    display:flex;
    height: calc(100vh - 16rem);
    align-items: flex-start;
    padding-left:0.5rem;
    box-sizing:border:box;
`;
export const DetailsPanelText = styled(TextSubHeader)`
  text-align: center;
  padding: 0 2rem;
`;

export const DetailsText = styled(Text)`
  text-align: center;
  padding: 0 2rem;
`;

export const Spacer = styled.div<{ height: string }>`
  height: ${(p) => p.height};
  width: 100%;
`;

export const SettinsMenu = styled.div`
  border-right: 0.1rem solid ${Colors.backgroundGray};
  width: 30rem;
  padding-right: 2rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  height: 100%;
`;
interface ISettinsMenuItemProps {
  isActive: boolean;
}
export const SettinsMenuItem = styled.div<ISettinsMenuItemProps>`
  cursor: pointer;
  ${(p) =>
    p.isActive &&
    `
     color: ${Colors.seaBlue};
    `}
  &:hover {
    color: ${Colors.seaBlue};
  }
`;
export const SettingsArea = styled.div`
  width: calc(100% - 30rem);
  padding-left: 2rem;
  display: flex;
`;

export const SettingsAreaColumn = styled.div`
  display: flex;
  width: 50%;
  padding: 1rem;
  flex-direction: column;
`;

export const SettingsAreaColumnTitle = styled.div`
  text-align: center;
  width: 100%;
  font-weight: bold;
  padding-bottom: 1rem;
`;

export const SettingsAreaColumnContent = styled.div`
  width: 100%;
  display: flex;
  background-color: ${Colors.tileGray};
  border-radius: 0.4rem;
`;

interface ISettingsAreaUnactiveColumn {
  isActive: boolean;
}
export const SettingsAreaUnactiveColumn = styled.div<ISettingsAreaUnactiveColumn>`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.tileGray};
  border: 2px dashed transparent;
  border-radius: 0.4rem;
  box-sizeing: border-box;
  padding: 2rem 0.9rem;

  ${(p) =>
    p.isActive &&
    `
   background-color: ${Colors.seaBlueTransparent};
  border: 2px dashed  ${Colors.seaBlue};
  `}
`;

export const SettingsDropArea = styled.div`
  width: 100%;
  display: flex;
  padding: 0 1rem;
  flex-direction: column;
`;

export const SettingsDropAreaUnactive = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2.2rem;
`;
export const TopBoxContent = styled.div`
  padding: 10px 0;
  margin-bottom: -1rem;
`;

export const LinkWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
